export default __webpack_public_path__ + "static/media/Blotting_Paper.5ad4ce0f.svg";